export const PAGE_LINKS = {
  login: '/login',
  home: '/',
  review: '/',
  materialLibrary: '/material/library',
  teamManage: '/team/manage',
  tagManage: '/tag/manage',
  workspaceManage: '/workspace/manage',
  redirect: '/redirect',
  visitor: '/visitor',
}

export const FILE_TYPE_MAP = {
  img: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico', 'tiff', 'tif'],
  video: ['mp4', 'webm', 'ogg'],
  font: ['ttf', 'otf', 'woff', 'woff2', 'eot'],
  ppt: ['ppt', 'pptx', 'pptm', 'pptxm'],
  pdf: ['pdf'],
  unknown: ['unknown'],
}

export const FILE_TYPE_OPTIONS = Object.values(FILE_TYPE_MAP)
  .flat(1)
  .filter((item) => item !== 'unknown')
  .map((item) => ({
    label: item,
    value: item,
  }))
